import { useMutation } from '@apollo/react-hooks';
import { kmsClient } from 'api';
import { UPDATE_CCA_SETTINGS_MUTATION } from './updateCcaSettings.mutation';
import {
  UpdateCcaSettingsMutation,
  UpdateCcaSettingsMutationVariables
} from './__generated__/UpdateCcaSettingsMutation';

export const useUpdateCcaSettings = () => {
  return useMutation<UpdateCcaSettingsMutation, UpdateCcaSettingsMutationVariables>(UPDATE_CCA_SETTINGS_MUTATION, {
    client: kmsClient
  });
};
